module.exports = new __parcel__URL__("C6O1.e6d23e2e.png").toString();